export class Pagination {

  private nItems: number;
  private currentPage: number;
  private itemsPerPage: number;
  private fromIndex: number;
  private toIndex: number;
  private nPages: number;

  constructor(nItems: number, itemsPerPage?: number) {
    this.nItems = nItems;
    this.currentPage = 0;
    this.itemsPerPage = itemsPerPage ? itemsPerPage : 10;
    this.fromIndex = 0;
    this.toIndex = this.itemsPerPage - 1;
    this.nPages = this.calculateNPages();
  }

  getNItems(): number { return this.nItems; }

  getCurrentPage(): number { return this.currentPage; }

  getItemsPerPage(): number { return this.itemsPerPage; }

  getFromIndex(): number { return this.fromIndex; }

  getToIndex(): number { return this.toIndex; }

  getNPages(): number { return this.nPages; }

  setNItems(nItems: number) { this.nItems = nItems; }

  setNPages(nPages: number) { this.nPages = nPages; }

  setCurrentPage(currentPage: number) { this.currentPage = currentPage; }


  incrementPage() {
    this.currentPage += 1;
    this.fromIndex += Number(this.itemsPerPage);
    this.toIndex += Number(this.itemsPerPage);
  }

  decrementPage() {
    this.currentPage -= 1;
    this.fromIndex -= this.itemsPerPage;
    this.toIndex -= this.itemsPerPage;
  }

  setItemsPerPage(n: number) {
    this.itemsPerPage = Number(n);
    this.nPages = this.calculateNPages();
    this.currentPage = Math.floor(this.fromIndex / n);//currentPage sarà quella in cui ricade il primo elemento della pigina corrente
    this.fromIndex = this.currentPage * n;
    this.toIndex = this.fromIndex + n - 1;
  }

  addItem() {
    this.nItems += 1;
    this.nPages = this.calculateNPages();
  }

  deleteItem() {
    this.nItems -= 1;
    this.nPages = this.calculateNPages();
  }

  reset() {
    this.currentPage = 0;
    this.fromIndex = 0;
    this.toIndex = this.itemsPerPage - 1;
  }

  calculateNPages(): number {
    return Math.ceil(this.nItems / this.itemsPerPage);
  }
}
